import React from "react";
import "./index.m.css";
import Whatsapp from "../../../atoms/social-media-icons/Whatsapp";
import Mail from "../../../atoms/social-media-icons/Mail";

export const FooterSection = () => {
  return (
    <div styleName="footerWrapper">
      <section styleName="footerSection" aria-label="Contact and Support">
        <div styleName="contactHeading">
          <span styleName="headingNormal">Facing issues? </span>
          <span styleName="headingBold">Contact us</span>
        </div>
        
        <div styleName="contactBoxes">
          <a 
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://api.whatsapp.com/send/?phone=919035267305&text=Hi%2C%20I%20need%20assistance%20with%20my%20Deccan%20Herald%20Premium%20Subscription.%20Could%20you%20please%20help%20me%3F&type=phone_number&app_absent=0", "_blank", "noopener,noreferrer");
            }}
            styleName="contactBox"
          >
            <Whatsapp width={18} height={18} color="#25D366" />
            <span styleName="whatsappText">+91 9035267305</span>
          </a>

          <a 
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://mail.google.com/mail/?view=cm&fs=1&to=support@deccanherald.com&su=Support%20Required%20for%20DH%20subscription&body=Hi%2C%20I%20need%20assistance%20with%20my%20Deccan%20Herald%20Premium%20Subscription.%20Could%20you%20please%20help%20me%3F", "_blank", "noopener,noreferrer");
            }}
            styleName="contactBox emailBox"
          >
            <Mail width={16} height={12} color="#000" />
            <span styleName="emailText">
              support@deccanherald.com
            </span>
          </a>
        </div>

        <div styleName="workingHoursContainer">
          <div styleName="workingHoursLabel">Working Hours</div>
          <div styleName="workingHoursTime">Mon - Fri : 10:00 AM to 6:00 PM</div>
        </div>
      </section>
    </div>
  );
};
